import { render, staticRenderFns } from "./UserAvatarPicker.vue?vue&type=template&id=f7752ef8&scoped=true&"
import script from "./UserAvatarPicker.vue?vue&type=script&lang=js&"
export * from "./UserAvatarPicker.vue?vue&type=script&lang=js&"
import style0 from "./UserAvatarPicker.vue?vue&type=style&index=0&id=f7752ef8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7752ef8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VBtn,VFileInput,VIcon})
